import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faLockOpen, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
//Components
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Helpers
import mascaras from '../../../../helpers/mascaras';

export default function FichaUsuarioContainer({ usuario, editUsuario, editAcessos }) {
    //cabeçalhos da tabela de permissões
    const headersAcessos = [
        { value: "Funcionalidade", objectValue: "tbFuncionalidades_Descricao", align: "left", color: "#666" },
        { value: "Permissao", objectValue: "permissao", align: "left" }

    ]
    return (
        <div style={{ color: "#666" }}>
            <h5 className='bg-gradient bg-primary rounded-3 p-2 d-flex align-items-center justify-content-between' style={{ color: "#fff" }}><span><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Identificação do usuario</span> {editUsuario && <button onClick={editUsuario} style={{ color: "#fff", border: "none", backgroundColor: "transparent" }}><FontAwesomeIcon icon={faEdit} /></button>}</h5>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Nome: </span>{usuario.nome}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">CPF / CNPJ: </span>{mascaras.cpfcnpjMask(usuario.cpfcnpj)}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Status: </span>{usuario.status}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Cargo: </span>{usuario.cargo != "" ? usuario.cargo : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Telefone: </span>{usuario.telefone != "" ? mascaras.celularMask(usuario.telefone) : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Matrícula: </span>{usuario.matricula != "" ? usuario.matricula : "Não informado"}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">E-mail: </span>{usuario.email}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Perfil: </span>{usuario.perfil}</p>
                </Col>
                {usuario.perfil == "Fiscal" &&
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Setores: </span>{usuario.setores.map(value => value.descricaoSetor ? value.descricaoSetor : value.label).toString()}</p>
                    </Col>
                }
            </Row>
            <h5 className='bg-gradient bg-primary rounded-3 p-2' style={{ color: "#fff" }}> <FontAwesomeIcon icon={faLockOpen} /><span> Permissões</span></h5>
            <TabelaListagemFichas paging={false} headers={headersAcessos} items={usuario.permissoes} />
        </div>
    )
}
